import dynamic from 'next/dynamic';

import ApplyBlindModalLink from '../../assets/apply_blind_modal_link.json';
import ApplyBlindModalMail from '../../assets/apply_blind_modal_mail.json';

const Lottie = dynamic(() => import('react-lottie'), { ssr: false });

export const CpeatsRequestCards = () => (
  <>
    <div className="border border-cds-coolgray-15 rounded-2xl py-5 px-3 text-center mb-3.5">
      <Lottie
        options={{ loop: true, autoplay: true, animationData: ApplyBlindModalLink }}
        width={81}
        height={77}
      />
      <p>
        <span className="text-cds-orange-55 font-semibold leading-[150%] tracking-[-0.176px]">
          내용이 없거나 재게시된 리뷰
        </span>
        <span className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
          는
        </span>
      </p>
      <p className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
        쿠팡이츠 정책에 따라 신청이 어려워요
      </p>
    </div>
    <div className="border border-cds-coolgray-15 rounded-2xl py-5 px-3 text-center">
      <div className="flex justify-center mb-3">
        <Lottie
          options={{ loop: true, autoplay: true, animationData: ApplyBlindModalMail }}
          width={81}
          height={77}
        />
      </div>
      <p className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
        신청 시 처리 완료까지 영업일 기준
      </p>
      <p>
        <span className="text-cds-orange-55 font-semibold leading-[150%] tracking-[-0.176px]">
          최대 2일까지 소요
        </span>
        <span className="text-cds-coolgray-85 font-normal leading-[150%] tracking-[-0.176px]">
          될 수 있어요
        </span>
      </p>
    </div>
  </>
);
